import React from 'react';
import { useTranslation } from 'react-i18next';

import { CloseDialogHandler, Dialog } from 'components';
import { TranslationNamespace } from 'i18n';

type Props = {
  open: boolean;
  selectedCount: number;
  onClose: CloseDialogHandler;
};

export const CancelOrdersDialog: React.FC<Props> = ({
  open,
  selectedCount,
  onClose,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.manual.cancel_dialog',
  });

  return (
    <Dialog open={open} title={t('title')} onClose={onClose}>
      <div>{t('description', { count: selectedCount })}</div>
      <div className="tw-mt-2">{t('warning')}</div>
    </Dialog>
  );
};
